export const environment = {
  siteVersion: require('../../package.json').version + '-homol',
  baseUrl: 'https://mobo-site-homol.netlify.app',
  baseApiUrl: 'https://mobo-site-homol.netlify.app/api',
  baseApiShareUrl: 'https://share.mobo.com.br/api',
  defaultImg: 'https://mobo-site-homol.netlify.app/assets/imgs/img-default.svg',
  env: 'homol'
};
